
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import EventItem2 from "@/components/items/event/EventItem2.vue";

@Component({
  components: {
    EventItem2,
  },
  filters,
})
export default class Events2 extends Vue {
  @Prop({ default: [] })
  private events!: Array<any>;
}
